jQuery(".1click").trigger("click");

jQuery(".no_aval_lable").on("click", function () {
  var newval = $(this).attr("for");
  console.log(newval);
  $(".hideclasss").hide();
  $(".hideclasss").hide();

  $(".instockproduct .hh" + newval).show();
  jQuery(".notifydiv").show();
  jQuery(".productadd").hide();
  jQuery(".productadd1").hide();
  $(".hhtotalstock").hide();

  var vall = $(this).attr("attbuteval");

  // $("input#BIS_trigger").attr("attbuteval", vall);
});
jQuery(".yes_aval_lable").on("click", function () {
  var newval = $(this).attr("for");
  console.log(newval);

  $(".hhtotalstock").hide();

  $(".hideclasss").hide();
  $(".instockproduct .hh" + newval).show();
  jQuery(".notifydiv").hide();
  jQuery(".productadd1").hide();

  jQuery(".productadd").show();
});

// $("#BIS_trigger").on("click", function (e) {
//   e.preventDefault();
//   var newval = $(this).attr("attbuteval");
// });

function getUrlParameter(search_param) {
  // get string of paramters
  var url_part = window.location.search.substring(1);
  // decode string
  var decoded_url_part = decodeURIComponent(url_part);
  // split on the basis of "&"
  var params = decoded_url_part.split("&");

  //iterate throw each param and find if it matches required component
  for (i = 0; i < params.length; i++) {
    param = params[i].split("=");
    if (search_param == param[0]) {
      return param[1];
    }
  }
  // console.log(splitted);
}
var message_param = getUrlParameter("size");
if (message_param != "") {
  $(".val_" + message_param).addClass("active");
  var vllk = $(".val_" + message_param).attr("attbuteval");

  jQuery("input[value=" + vllk + "]").attr("checked", true);
}
